import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight, Calendar, MapPin, Expand, Minimize, GalleryHorizontal, Flame, } from 'lucide-react';
import ImagesDev from '../api/images';
import EventGallery from '../api/eventGallery';
import { fetchCategories } from '../api/mediaService';


const Tags = [
  { id: 'all', label: 'All Events' },
  { id: 'conferences', label: 'Conferences' },
  { id: 'worship', label: 'Worship' },
  { id: 'outreach', label: 'Outreach' },
  { id: 'youth', label: 'Youth' },
];

const images = [
  {
    id: 1,
    category: 'conferences',
    url: ImagesDev.litsImg,
    title: 'Life in the Spirit',
    date: "February 28, 2025",
    location: "3c, Olaide Benson Close, Maryland, Lagos.",
  },
  {
    id: 2,
    category: 'conferences',
    url: ImagesDev.BSImg,
    title: "How To Read The Bible",
    date: "October 26, 2024",
    location: "NECA House, Hakeem Balogun Street, Alausa, Ikeja.",
  },
  // {
  //   id: 3,
  //   category: 'outreach',
  //   url: ImagesDev.hpGImg,
  //   title: "The Healing Party - Ghana",
  //   date: "November 30, 2024",
  //   location: "Shekinah Avenue Auditorium, Accra.",
  // },
  // {
  //   id: 4,
  //   category: 'outreach',
  //   url: ImagesDev.thpImg,
  //   title: "The Healing Party - Ibadan",
  //   date: "November 30, 2024",
  //   location: "Christ The Dayspring Church, Ibadan.",
  // },
  // Add more images as needed
];

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTag, setActiveTag] = useState('all');
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  // const [selectedImage, setSelectedImage] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isImageOpened, setIsImageOpened] = useState(false);
  const [showAllImages, setShowAllImages] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [MediaData, setMediaData] = useState([]);
  const [categories, setCategories] = useState([]);

  // const allImages = EventGallery.flatMap(event => event.images);
  const allImages = MediaData;
  // const currentImages = showAllImages
  // ? allImages
  // : selectedEvent
  //   ? allImages.filter(image => image.attachment_category === parseInt(selectedEvent)) // Ensure correct filtering
  //   : [];
  const currentImages = showAllImages
    ? allImages
    : selectedEvent
      ? allImages.filter(image => Number(image.attachment_category) === Number(selectedEvent))
      : [];


  const filteredCategories = categories?.filter(
    card => activeTag === 'all' || (card.tags && card.tags.includes(activeTag))
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // useEffect(() => {
  //   const GALLERY_KEY = "gallery_resources";

  //   const fetchData = async () => {
  //     const categoryMap = await fetchCategories();
  //     setCategories(categoryMap);
  //     let allMedia = [];
  //     let page = 1;
  //     let totalPages = 1;

  //     try {
  //       while (page <= totalPages) {
  //         const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/media?per_page=100&page=${page}&_embed`);
  //         const data = await response.json();

  //         if (response.headers.get("X-WP-TotalPages")) {
  //           totalPages = parseInt(response.headers.get("X-WP-TotalPages"), 10);
  //         }

  //         allMedia = [...allMedia, ...data];
  //         const filteredData = allMedia.filter(item => !item.attachment_tag?.includes(18));
  //         setMediaData(filteredData);

  //         page++;
  //       }

  //       const filteredData = allMedia.filter(item => !item.attachment_tag?.includes(18));
  //       setMediaData(filteredData);
  //       localStorage.setItem(GALLERY_KEY, JSON.stringify(filteredData));
  //       // console.log(filteredData);
  //     } catch (error) {
  //       console.error("Error fetching media:", error);
  //     }
  //   };

  //   const loadResources = async () => {
  //     const cachedData = localStorage.getItem(GALLERY_KEY);
  //     if (cachedData) {
  //       setMediaData(JSON.parse(cachedData));
  //       alert("the app used from cache")
  //     } else {
  //       fetchData()
  //     }
  //   };

  //   loadResources();
  // }, []);


  useEffect(() => {
    const GALLERY_KEY = "gallery_resources";

    const fetchAllMedia = async () => {
      try {
        let allMedia = [];
        let page = 1;
        let totalPages = 1;

        const categoryMap = await fetchCategories();
        setCategories(categoryMap);

        while (page <= totalPages) {
          const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/media?per_page=100&page=${page}&_embed`);
          const data = await response.json();

          // Grab totalPages from headers on first request
          if (page === 1 && response.headers.get("X-WP-TotalPages")) {
            totalPages = parseInt(response.headers.get("X-WP-TotalPages"), 10);
          }

          allMedia = [...allMedia, ...data];
          const filteredData = allMedia.filter(item => !item.attachment_tag?.includes(18));
          setMediaData(filteredData);
          page++;
        }

        const filteredData = allMedia.filter(item => !item.attachment_tag?.includes(18));
        setMediaData(filteredData);
        localStorage.setItem(GALLERY_KEY, JSON.stringify(filteredData));
      } catch (error) {
        console.error("Error fetching media:", error);
      }
    };

    const loadResources = async () => {
      const cachedData = localStorage.getItem(GALLERY_KEY);

      if (cachedData) {
        console.log("Loaded from localStorage");
        setMediaData(JSON.parse(cachedData));
        alert("The app used data from cache ✅");
      } else {
        console.log("No cache found. Fetching everything from WordPress...");
        await fetchAllMedia();
      }
    };

    loadResources();
  }, []);

  // useEffect(() => {
  //   // localStorage.setItem("test_key", "Hello");
  //   console.log(localStorage.getItem("test_key"));
  // }, [])


  const handleEventClick = (eventId) => {
    setSelectedEvent(eventId);
    setShowModal(true);
    setShowAllImages(false);
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsImageOpened(true)
    isMobile && setIsExpanded(true)
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
    setIsExpanded(false);
    setSelectedEvent(null);
    setIsImageOpened(false)
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24"
    >
      <div className="container mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Event Gallery</h1>
          <p className="text-xl text-gray-300">Capturing moments of faith, fellowship, and transformation</p>
        </div>

        {/* Categories */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {Tags.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveTag(category.id)}
              className={`px-6 py-2 rounded-full transition-colors ${activeTag === category.id
                ? 'bg-amber-600 text-white'
                : 'bg-white/10 text-gray-300 hover:bg-white/20'
                }`}
            >
              {category.label}
            </button>
          ))}
        </div>


        {/* <p>{JSON.stringify(selectedEvent)}</p> */}

        {/* {currentImages.map((item) => (
          <div key={item.id} className="p-2 border rounded-lg shadow-md">

            <h3 className="text-lg font-semibold mt-2">{item.title.rendered}</h3>

            {item.tags && item.tags.length > 0 && (
              <p className="text-sm text-gray-600">Tags: {item.tags.join(", ")}</p>
            )}

            {item.attachment_category && item.attachment_category.length > 0 && (
              <p className="text-sm text-gray-600">
                Categories: {categories
                  ?.filter(card => item.attachment_category.includes(card.id))
                  ?.map(card => card.name)
                  ?.join(", ")}
              </p>
            )}
          </div>
        ))} */}

        {/* Image Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredCategories ? filteredCategories
            .slice() // copy to avoid mutating original array
            .sort((a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime())
            .map((card, index) => {
              // Check if the image URL follows WordPress's default size structure
              const optimizedImageUrl = card.imageUrl.includes('-300x300')
                ? card.imageUrl
                : card.imageUrl.replace(/(\.[a-z]+)$/, "-300x300$1");

              return (
                <motion.div key={card.id} layout initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="relative group">
                  <div onClick={() => handleEventClick(card.id.toString())}
                    className={`cursor-pointer relative overflow-hidden rounded-lg aspect-[4/3] ${index === 0 && "border-4 border-orange-600 animate-pulse"}`}
                  >
                    <img
                      src={card.imageUrl}
                      onError={(e) => (e.target.src = card.imageUrl)} // Fallback to original image if optimized version doesn't exist
                      alt={card.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-0 left-0 right-0 p-6">
                        <h3 className="text-xl font-bold mb-2">{card.name}</h3>
                        <div className="flex items-center gap-4 text-sm">
                          <div className="flex items-center gap-2">
                            <Calendar className="w-4 h-4" />
                            <span>{card.eventDate}</span>
                          </div>
                          <div className="flex items-center gap-2">
                            <MapPin className="w-4 h-4" />
                            <span>{card.location}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {index === 0 && <p className='absolute -top-3 bg-orange-600 p-2 rounded-2xl font-bold text-sm animate-bounce flex gap-1 items-center justify-center'><Flame /> Latest Event!</p>}
                </motion.div>
              );
            })
            :
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto" />
          }
        </div>


      </div>


      {/* Gallery Modal */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center"
          >
            {/* All Top Navigation */}
            <div>
              <div className="absolute top-4 left-6 z-50 flex space-x-4">
                <button
                  onClick={handleClose}
                  className="p-2 px-4 backdrop-blur-sm bg-black/50 md:bg-white/10 rounded-full hover:bg-white/20 transition-colors flex"
                >
                  <X className="w-6 h-6" /> Close
                </button>
              </div>

              {isImageOpened === true && <div className="absolute top-14 right-14 z-50 flex space-x-4">
                {!isMobile && <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="p-2 bg-black/10 rounded-full hover:bg-black/20 transition-colors"
                >
                  {isExpanded ? (
                    <Minimize className="w-6 h-6" />
                  ) : (
                    <Expand className="w-6 h-6" />
                  )}
                </button>}
                <button
                  onClick={() => {
                    setIsImageOpened(false)
                    setIsExpanded(false)
                    setSelectedImage(null);
                  }}
                  className="p-2 bg-black/10 rounded-full hover:bg-black/20 transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>}
            </div>

            {/* Displays */}
            <div className={`relative w-full h-full flex ${isExpanded ? "p-0" : "md:p-10"}`}>
              <motion.div
                initial={{ height: "85vh", backgroundColor: "rgb(17, 24, 39)" }}
                animate={{ height: isExpanded ? "100vh" : "85vh", backgroundColor: isExpanded ? "rgb(0, 0, 0)" : "rgb(17, 24, 39)", }}
                className="relative w-full flex bg-gray-900 overflow-hidden rounded-3xl"
              >
                {/* Gallery Grid */}
                <motion.div
                  initial={{ width: "100%" }}
                  animate={{ width: isExpanded && selectedImage ? "0%" : isImageOpened === false ? "100%" : "50%" }}
                  className="h-full overflow-y-auto p-3 pt-8 md:p-8"
                  style={{ display: isExpanded && selectedImage ? 'none' : 'block' }}
                >
                  {currentImages && currentImages.length >= 1 ?
                    <div className={`grid grid-cols-3 ${isImageOpened === false ? "md:grid-cols-6" : "md:grid-cols-3"} gap-1 md:gap-4`}>
                      {currentImages.map((image) =>
                        <ImageThumbNail image={image} selectedImage={selectedImage} handleImageClick={handleImageClick} />
                      )}
                    </div>
                    :
                    <div className='h-[100%] w-[100%] flex items-center justify-center'>
                      <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto" />
                    </div>
                  }
                </motion.div>

                {/* Selected Image View */}
                <motion.div
                  initial={{ width: "0%", opacity: 1 }}
                  animate={{ width: isExpanded ? "100%" : isImageOpened ? "50%" : "0%", opacity: isExpanded ? 1 : isImageOpened ? 1 : 0, }}
                  className={`h-[100%] border-l border-white/10 ${isExpanded ? "p-8" : isImageOpened ? "p-8" : "0%"}`}
                >
                  {selectedImage ? (
                    <div className="h-[100%] flex flex-col">
                      <div className="flex-1 relative">
                        <img
                          src={selectedImage.source_url}
                          alt={selectedImage.slug}
                          className="w-full h-[80vh] object-contain"
                        />
                        <button
                          onClick={() => {
                            const currentIndex = currentImages.findIndex(img => img.id === selectedImage.id);
                            const prevImage = currentImages[currentIndex - 1];
                            if (prevImage) setSelectedImage(prevImage);
                          }}
                          className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 bg-black/50 rounded-full hover:bg-black/70 transition-colors"
                        >
                          <ChevronLeft className="w-6 h-6" />
                        </button>
                        <button
                          onClick={() => {
                            const currentIndex = currentImages.findIndex(img => img.id === selectedImage.id);
                            const nextImage = currentImages[currentIndex + 1];
                            if (nextImage) setSelectedImage(nextImage);
                          }}
                          className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 bg-black/50 rounded-full hover:bg-black/70 transition-colors"
                        >
                          <ChevronRight className="w-6 h-6" />
                        </button>
                      </div>
                      <div className="mt-4">
                        <h3 className="text-xl font-bold">
                          {categories
                            ?.filter(card => selectedImage.attachment_category.includes(card.id))
                            ?.map(card => card.name)
                            ?.join(", ")}
                        </h3>
                        {/* <p className="text-gray-400 mt-2">{selectedImage.description}</p>
                        <p className="text-sm text-gray-500 mt-2">
                          {new Date(selectedImage.date).toLocaleDateString()}
                        </p> */}
                      </div>
                    </div>
                  ) : (
                    <div className="h-full flex items-center justify-center text-gray-500">

                    </div>
                  )}
                </motion.div>
              </motion.div>
            </div>

            {/* Bottom Navigation */}
            <motion.div
              initial={{ bottom: 0 }}
              animate={{ bottom: isExpanded ? "-10vh" : 0 }}
              className="absolute bottom-0 left-0 right-0 bg-gray-200/80 md:bg-black/50 backdrop-blur-sm p-2 pt-6 md:p-4 rounded-2xl">
              {isMobile && <p className='p-1 text-gray-800 flex flex-row gap-1'><GalleryHorizontal /> Tap to view</p>}
              <div className="container mx-auto flex items-center justify-between overflow-x-scroll md:overflow-x-scroll">
                <div className="flex space-x-2 md:space-x-4">
                  {filteredCategories.map((event) => {
                    const optimizedImageUrl = event.imageUrl.includes('-300x300')
                      ? event.imageUrl
                      : event.imageUrl.replace(/(\.[a-z]+)$/, "-300x300$1");
                    return (
                      <button
                        key={event.id}
                        onClick={() => {
                          setSelectedEvent(event.id.toString());
                          setShowAllImages(false);
                          setSelectedImage(null);
                          setIsImageOpened(false)
                          setIsExpanded(false);
                        }}
                        className={`relative flex flex-row md:p-1 p-[1px] w-[90px] h-[90px] md:w-full md:h-[70px] rounded-xl transition-colors overflow-hidden ${selectedEvent === event.id.toString()
                          ? 'bg-amber-600 text-white border-amber-500 border-2 md:border-amber-500/0 md:border-0'
                          : 'bg-black/10 hover:bg-white/20'
                          }`}
                      >
                        <img
                          src={optimizedImageUrl}
                          onError={(e) => (e.target.src = event.imageUrl)}
                          alt={event.slug}
                          className="w-full h-full md:w-[60px] md:h-[60px] rounded-xl object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <p className='absolute flex justify-center items-center md:p-2 md:justify-start md:text-left rounded-xl top-[-3px] left-[-3px] w-full h-full md:h-[60px] bg-black/40 md:bg-black/0 md:relative text-[7px] md:text-sm m-1'>
                          {isMobile ? event.name.slice(0, 20) : event.name}
                        </p>
                      </button>
                    )
                  })}
                  <button
                    onClick={() => {
                      setShowAllImages(true);
                      setSelectedEvent(null);
                      setSelectedImage(null);
                      setIsImageOpened(false)
                      setIsExpanded(false);
                    }}
                    className={`relative flex flex-row md:p-1 p-[1px] w-[90px] h-[90px] md:w-full md:h-[70px] rounded-xl transition-colors overflow-hidden ${showAllImages
                      ? 'bg-amber-600 text-white border-amber-500 border-2'
                      : 'bg-black/10 hover:bg-white/20'
                      }`}
                  >
                    <img
                      src={EventGallery[0].images[0].url}
                      alt={EventGallery[0].images[0].title}
                      className="w-full h-full md:w-[60px] md:h-[60px] rounded-xl object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <p className='absolute flex justify-center items-center md:p-2 md:justify-start rounded-xl top-[-3px] left-[-3px] w-full h-full md:h-[60px] bg-black/40 md:bg-black/0 md:relative text-[7px] md:text-sm m-1'>
                      All Images
                    </p>
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}



const ImageThumbNail = ({ image, selectedImage, handleImageClick }) => {
  const [loaded, setLoaded] = useState(false);

  // const optimizedImageUrl = image.source_url.includes("-300x300")
  //   ? image.source_url
  //   : image.source_url.replace(/(\.[a-z]+)$/, "-300x300$1");
  const optimizedImageUrl =
    image.media_details?.sizes?.["medium_large"]?.source_url ||
    image.media_details?.sizes?.["thumbnail"]?.source_url ||
    image.source_url;



  return (
    <motion.div
      key={image.id}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={`relative cursor-pointer md:rounded-2xl overflow-hidden ${selectedImage?.id === image.id ? "ring-2 ring-orange-500" : ""
        }`}
      onClick={() => handleImageClick(image)}
    >
      {/* Loading placeholder */}
      {!loaded && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse z-10" />
      )}
      {/* <p>{JSON.stringify(image.media_details?.sizes?.medium?.source_url)}</p> */}
      <img
        src={optimizedImageUrl}
        alt={image.slug}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)} // so it doesn't get stuck if image fails
        className={`w-full h-36 md:h-40 object-cover transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"
          }`}
      />
    </motion.div>
  );
}




function Gallery_() {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showAllImages, setShowAllImages] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);


  const allImages = EventGallery.flatMap(event => event.images);
  const currentImages = showAllImages
    ? allImages
    : selectedEvent
      ? EventGallery.find(e => e.id.toString() === selectedEvent)?.images || []
      : [];

  const handleEventClick = (eventId) => {
    setSelectedEvent(eventId);
    setShowModal(true);
    setShowAllImages(false);
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
    setIsExpanded(false);
    setSelectedEvent(null);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-24"
    >
      {/* Main Gallery Grid */}
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold mb-8 text-center">Event Gallery</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {EventGallery.map((event) => (
            <motion.div
              key={event.id}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="relative group cursor-pointer overflow-hidden rounded-xl"
              onClick={() => handleEventClick(event.id.toString())}
            >
              <img
                src={event.images[0]?.url}
                alt={event.name}
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <h3 className="text-2xl font-bold text-white">{event.name}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Gallery Modal */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center"
          >
            <div className="absolute top-4 right-4 z-50 flex space-x-4">
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
              >
                {isExpanded ? (
                  <Minimize className="w-6 h-6" />
                ) : (
                  <Expand className="w-6 h-6" />
                )}
              </button>
              <button
                onClick={handleClose}
                className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="w-full h-full flex">
              {/* Gallery Grid */}
              <motion.div
                initial={{ width: "50%" }}
                animate={{ width: isExpanded && selectedImage ? "0%" : "50%" }}
                className="h-full overflow-y-auto p-8"
                style={{ display: isExpanded && selectedImage ? 'none' : 'block' }}
              >
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {currentImages.map((image) => (
                    <motion.div
                      key={image.id}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      className={`relative cursor-pointer rounded-lg overflow-hidden ${selectedImage?.id === image.id ? 'ring-2 ring-purple-500' : ''
                        }`}
                      onClick={() => handleImageClick(image)}
                    >
                      <img
                        src={image.url}
                        alt={image.title}
                        className="w-full h-40 object-cover"
                      />
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              {/* Selected Image View */}
              <motion.div
                initial={{ width: "50%" }}
                animate={{ width: isExpanded ? "100%" : "50%" }}
                className="h-full p-8 border-l border-white/10"
              >
                {selectedImage ? (
                  <div className="h-full flex flex-col">
                    <div className="flex-1 relative">
                      <img
                        src={selectedImage.url}
                        alt={selectedImage.title}
                        className="w-full h-full object-contain"
                      />
                      <button
                        onClick={() => {
                          const currentIndex = currentImages.findIndex(img => img.id === selectedImage.id);
                          const prevImage = currentImages[currentIndex - 1];
                          if (prevImage) setSelectedImage(prevImage);
                        }}
                        className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 bg-black/50 rounded-full hover:bg-black/70 transition-colors"
                      >
                        <ChevronLeft className="w-6 h-6" />
                      </button>
                      <button
                        onClick={() => {
                          const currentIndex = currentImages.findIndex(img => img.id === selectedImage.id);
                          const nextImage = currentImages[currentIndex + 1];
                          if (nextImage) setSelectedImage(nextImage);
                        }}
                        className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 bg-black/50 rounded-full hover:bg-black/70 transition-colors"
                      >
                        <ChevronRight className="w-6 h-6" />
                      </button>
                    </div>
                    <div className="mt-4">
                      <h3 className="text-xl font-bold">{selectedImage.title}</h3>
                      <p className="text-gray-400 mt-2">{selectedImage.description}</p>
                      <p className="text-sm text-gray-500 mt-2">
                        {new Date(selectedImage.date).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="h-full flex items-center justify-center text-gray-500">
                    Select an image to view details
                  </div>
                )}
              </motion.div>
            </div>

            {/* Bottom Navigation */}
            <div className="absolute bottom-0 left-0 right-0 bg-black/50 backdrop-blur-sm p-4">
              <div className="container mx-auto flex items-center justify-between">
                <div className="flex space-x-4">
                  {EventGallery.map((event) => (
                    <button
                      key={event.id}
                      onClick={() => {
                        setSelectedEvent(event.id.toString());
                        setShowAllImages(false);
                        setSelectedImage(null);
                      }}
                      className={`px-4 py-2 rounded-full transition-colors ${selectedEvent === event.id.toString()
                        ? 'bg-purple-600 text-white'
                        : 'bg-white/10 hover:bg-white/20'
                        }`}
                    >
                      {event.name}
                    </button>
                  ))}
                  <button
                    onClick={() => {
                      setShowAllImages(true);
                      setSelectedEvent(null);
                      setSelectedImage(null);
                    }}
                    className={`px-4 py-2 rounded-full transition-colors ${showAllImages
                      ? 'bg-purple-600 text-white'
                      : 'bg-white/10 hover:bg-white/20'
                      }`}
                  >
                    All Images
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

export default Gallery;








{/* Lightbox */ }
{/* <AnimatePresence>
{selectedImage && (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center"
    onClick={() => setSelectedImage(null)}
  >
    <button
      className="absolute top-4 right-4 p-2 hover:bg-white/10 rounded-full transition-colors"
      onClick={() => setSelectedImage(null)}
    >
      <X className="w-6 h-6" />
    </button>

    <button
      className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 hover:bg-white/10 rounded-full transition-colors"
      onClick={(e) => {
        e.stopPropagation();
        const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
        const prevImage = filteredImages[currentIndex - 1];
        if (prevImage) setSelectedImage(prevImage);
      }}
    >
      <ChevronLeft className="w-6 h-6" />
    </button>

    <button
      className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 hover:bg-white/10 rounded-full transition-colors"
      onClick={(e) => {
        e.stopPropagation();
        const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
        const nextImage = filteredImages[currentIndex + 1];
        if (nextImage) setSelectedImage(nextImage);
      }}
    >
      <ChevronRight className="w-6 h-6" />
    </button>

    <div className="max-w-4xl w-full p-4">
      <img
        src={selectedImage.url}
        alt={selectedImage.title}
        className="w-full h-auto rounded-lg"
        onClick={(e) => e.stopPropagation()}
      />
      <div className="mt-4 text-center">
        <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
        <div className="flex justify-center items-center gap-4 text-gray-300">
          <div className="flex items-center gap-2">
            <Calendar className="w-4 h-4" />
            <span>{selectedImage.date}</span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4" />
            <span>{selectedImage.location}</span>
          </div>
        </div>
      </div>
    </div>
  </motion.div>
)}
</AnimatePresence> */}